import React, { useEffect } from "react";
import { Card, Form, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAdminTestContacts, deleteAdminTestContact } from "../../store/slices/hodublast";
import { useParams } from "react-router-dom";
import { loadCampaign } from "../../store/slices/campaigns/createCampaign";

function SetOtherIvr(props) {
    const {
        emailCc,
        setEmailCc,
        emailBcc,
        setEmailBcc,
        ccList,
        setCcList,
        bccList,
        setBccList,
        adminTestContact,
        setAdminTestContact,
        adminTestContactList,
        setAdminTestContactList,
        campaign
    } = props;

    const { adminTestContacts } = useSelector((store) => store.hodublastReducer);
    const { data } = adminTestContacts;
    const { id } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (id) {
            dispatch(loadCampaign(id));
            console.log("Loading campaign data from step third !!!");
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (campaign?.data?.id) {
            dispatch(getAdminTestContacts({ campaign_id: campaign.data.id }));
        }
    }, [campaign?.data?.id]);

    useEffect(() => {
        if (data && Array.isArray(data) && data.length > 0) {
            const contactNumbers = data.map(c => c.admin_contact_number);
            setAdminTestContactList(contactNumbers);
        }
    }, [data, setAdminTestContactList]);


    const handleAddEmail = (value, setList, list, setValue) => {
        const email = value.trim();
        if (!email) return;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) return alert("Invalid email address!");
        if (list.includes(email)) return alert("Email already added!");
        setList([...list, email]);
        setValue("");
    };

    const handleAddContact = (value, setList, list, setValue) => {
        const contact = value.trim();
        if (!contact) return;
        const contactRegex = /^[6-9]\d{9}$/; // 10-digit Indian mobile validation
        if (!contactRegex.test(contact))
            return alert("Please enter a valid 10-digit contact number!");
        if (list.includes(contact)) return alert("Contact already added!");
        setList([...list, contact]);
        setValue("");
    };

    const handleRemove = async (item, setList, list, type = "email") => {
        setList(list.filter((e) => e !== item));

        if (type === "contact" && campaign?.data?.id) {
            try {
                await dispatch(
                    deleteAdminTestContact({
                        campaign_id: campaign.data.id,
                        contact_number: item,
                    })
                ).unwrap();

                // 🔥 Re-fetch the updated list from backend
                dispatch(getAdminTestContacts({ campaign_id: campaign.data.id }));

                console.log(`Removed contact ${item} from campaign ${campaign.data.name}`);
            } catch (error) {
                console.error("Failed to delete contact:", error);
            }
        }
    };

    const handleKeyPress = (e, value, addFn, setList, list, setValue) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addFn(value, setList, list, setValue);
        }
    };

    return (
        <Card className="p-4 shadow-sm border-0 rounded-4">
            <h5 className="mb-4 text-primary fw-bold border-bottom pb-2">
                Set Emails for Reporting
            </h5>

            {/* Email TO */}
            <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Email To</Form.Label>
                <Form.Control
                    type="email"
                    placeholder="Type email and press Enter"
                    value={emailCc}
                    onChange={(e) => setEmailCc(e.target.value)}
                    onKeyDown={(e) =>
                        handleKeyPress(e, emailCc, handleAddEmail, setCcList, ccList, setEmailCc)
                    }
                    className="rounded-3 shadow-sm"
                />
                <div className="mt-2">
                    {ccList.map((email, index) => (
                        <Badge
                            key={index}
                            bg="info"
                            className="me-2 mb-2 p-2 rounded-pill"
                            style={{ cursor: "pointer", fontSize: "0.85rem" }}
                            onClick={() => handleRemove(email, setCcList, ccList, "email")}
                        >
                            {email} ×
                        </Badge>
                    ))}
                </div>
            </Form.Group>

            {/* Email CC */}
            <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Email CC</Form.Label>
                <Form.Control
                    type="email"
                    placeholder="Type email and press Enter"
                    value={emailBcc}
                    onChange={(e) => setEmailBcc(e.target.value)}
                    onKeyDown={(e) =>
                        handleKeyPress(e, emailBcc, handleAddEmail, setBccList, bccList, setEmailBcc)
                    }
                    className="rounded-3 shadow-sm"
                />
                <div className="mt-2">
                    {bccList.map((email, index) => (
                        <Badge
                            key={index}
                            bg="secondary"
                            className="me-2 mb-2 p-2 rounded-pill"
                            style={{ cursor: "pointer", fontSize: "0.85rem" }}
                            onClick={() => handleRemove(email, setBccList, bccList, "email")}
                        >
                            {email} ×
                        </Badge>
                    ))}
                </div>
            </Form.Group>

            <h5 className="mb-4 text-success fw-bold border-bottom pb-2">
                Set Admin Contact Numbers for IVR Testing (Optional)
            </h5>

            {/* Admin Contact Numbers */}
            <Form.Group>
                <Form.Label className="fw-semibold">Admin Contact Number</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Type number and press Enter"
                    value={adminTestContact}
                    onChange={(e) => setAdminTestContact(e.target.value)}
                    onKeyDown={(e) =>
                        handleKeyPress(
                            e,
                            adminTestContact,
                            handleAddContact,
                            setAdminTestContactList,
                            adminTestContactList,
                            setAdminTestContact
                        )
                    }
                    className="rounded-3 shadow-sm"
                />
                <div className="mt-2">
                    {adminTestContactList.map((contact, index) => (
                        <Badge
                            key={index}
                            bg="success"
                            className="me-2 mb-2 p-2 rounded-pill"
                            style={{ cursor: "pointer", fontSize: "0.9rem" }}
                            onClick={() =>
                                handleRemove(
                                    contact,
                                    setAdminTestContactList,
                                    adminTestContactList,
                                    "contact"
                                )
                            }
                        >
                            {contact} ×
                        </Badge>
                    ))}
                </div>
            </Form.Group>
        </Card>
    );
}

export default SetOtherIvr;
